import type { AiAgentModel } from "@ext/agent/llm";
import { create } from "zustand";

export type AgentChatTarget = "enterprise" | "enterprise-cloud" | "docportal";
export type AgentChatHealthcheckStatus = "idle" | "checking" | "available" | "unavailable";
export type AgentChatHealthcheckReason = "balance_empty" | "access_denied" | "access_restricted" | "unavailable";

export interface AgentChatHealthcheckState {
	status: AgentChatHealthcheckStatus;
	target?: AgentChatTarget;
	reason?: AgentChatHealthcheckReason;
	models?: AiAgentModel[];
	modelPickAvailable?: boolean;
	imageRecognitionModel?: AiAgentModel;
}

interface AgentChatHealthcheckStateStore {
	state: AgentChatHealthcheckState;
	setState: (newState: AgentChatHealthcheckState) => void;
}

export const useAgentChatHealthcheckStore = create<AgentChatHealthcheckStateStore>()((set) => ({
	state: { status: "idle" },
	setState: (state) => set({ state }),
}));

export const useAgentChatHealthcheck = () => useAgentChatHealthcheckStore((state) => state.state);

export const setAgentChatHealthcheck = (state: AgentChatHealthcheckState) =>
	useAgentChatHealthcheckStore.getState().setState(state);
